export * from '../../sidenavLogo.constants';

export const MIN_INDEX = 1;

export const MAX_INDEX = 12;

export const UPDATE_TIMEOUT_MS = 300;
